module.exports = __webpack_public_path__ + "static/media/ic_on_a_mission_yellow.705ad9ae.svg";